export default __webpack_public_path__ + "static/media/bar-cards-memory.8325908f.svg";